import { Skeleton } from '@hero/web-components';

/**
 * Placeholder for {@link RequirementsCard} while client legal /
 * agreement gates are still being evaluated. Mirrors the real card's
 * layout so the section doesn't flash red "missing" states before
 * the API has answered.
 */
export function RequirementsCardSkeleton() {
  return (
    <div
      aria-hidden="true"
      className="flex w-full items-start gap-3 rounded-2xl border border-gray-200 bg-white p-4">
      <Skeleton className="size-9 shrink-0 rounded-full" />

      <div className="min-w-0 flex-1 space-y-2">
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-16 rounded-full" />
        </div>
        <Skeleton className="h-3 w-full max-w-sm" />
        <Skeleton className="h-3 w-3/4 max-w-xs" />
      </div>

      <Skeleton className="h-4 w-14 shrink-0 self-center" />
    </div>
  );
}
